import React, { useState, useRef, useCallback, useEffect } from 'react'

import Layout from '../../Layout';
import { Tabs, TabsProps, Skeleton, Button, Modal, Spin, Typography } from 'antd';
import { ExportOutlined, DownloadOutlined } from '@ant-design/icons';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './styles.scss'
import Overview from './components/Overview';
import VehicleInformation from './components/VehicleInformation';
import InvoiceHistory from './components/InvoiceHistory';
import UpdateHistory from './components/DetailsCleanedUpdateHistory';
import InteractionHistory from './components/InteractionHistory';
import { selectorSourceColumnWarehouse } from '../../store/slices/sourceColumnWarehouseSlice';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { useSelector } from 'react-redux';
import { mixGetV2, mixPostV2, mixPostV3 } from '../../services/mixin'

// import './stylesv2.scss'
import Infomation from './components/Infomation';
import InfomationLeft from './components/InfomationLeft';
import { get } from 'lodash';

const EXPORT_JSON_CACHE_CONFIG = [
  { name: 'TbCacheInfomationLeftCn', type_api: 1 },
  { name: 'TbCacheContactPerson', type_api: 2 },
  { name: 'TbCacheOwnedCar', type_api: 3 },
  { name: 'TbCacheUsedCar', type_api: 4 },
  { name: 'TbCacheInterestedCar', type_api: 5 },
  { name: 'TbCacheVehicleInvoice', type_api: 6 },
  { name: 'TbCacheVehicleInvoiceDetail', type_api: 66 },
  { name: 'TbCacheServiceMaintenanceInvoice', type_api: 7 },
  { name: 'TbCacheServiceMaintenanceInvoiceDetail', type_api: 77 },
  { name: 'TbCacheSalesAndService', type_api: 8 },
  { name: 'TbCacheSupportHistory', type_api: 9 },
  { name: 'TbCacheSurveyInformation', type_api: 10 },

] as const;

const EXPORT_JSON_CACHE_NAMES = EXPORT_JSON_CACHE_CONFIG.map((c) => c.name);

const CustomerInforNew = () => {
  const sourceColumnWarehouseRaw = useSelector(selectorSourceColumnWarehouse);
  // Normalize to a flat array for label lookup only — never mutate or dispatch to store
  const sourceColumnWarehouseArr: any[] = (() => {
    if (Array.isArray(sourceColumnWarehouseRaw)) return sourceColumnWarehouseRaw;
    if (Array.isArray(sourceColumnWarehouseRaw?.items)) return sourceColumnWarehouseRaw.items;
    if (sourceColumnWarehouseRaw && typeof sourceColumnWarehouseRaw === 'object') {
      // Store is an object with category-group keys, each having a .list array of columns
      return (Object.values(sourceColumnWarehouseRaw) as any[])
        .flatMap((cat: any) => (Array.isArray(cat?.list) ? cat.list : []));
    }
    return [];
  })();

  const getLabelFromSourceColumnWarehouse = (key: string): string => {
    const col = sourceColumnWarehouseArr.find(
      (x: any) =>
        x?.field === key ||
        x?.code === key ||
        x?.column_warehouse?.column === key ||
        x?.dataIndex === key
    );
    return col?.headerName || col?.name || col?.title || key;
  };
  const user = useSelector(selectorInfoUser);
  const navigate = useNavigate()
  const [stData, setStData] = useState({
    contact_person: [],
    contact_person_total: 0,
    contact_person_loading: true,
    contact_person_params_page: 1,
    contact_person_params_limit: 10,

    vehicle_invoice_sale: [],
    vehicle_invoice_sale_total: 0,
    vehicle_invoice_sale_loading: true,
    vehicle_invoice_sale_params_page: 1,
    vehicle_invoice_sale_params_limit: 10,
    vehicle_invoice_sale_params_branch_name: null,
    vehicle_invoice_sale_params_chassis_no: null,

    service_invoice_service: [],
    service_invoice_service_total: 0,
    service_invoice_service_loading: true,
    service_invoice_service_params_page: 1,
    service_invoice_service_params_limit: 10,
    service_invoice_service_params_branch_name: null,
    service_invoice_service_params_chassis_no: null,

    customers_repair_appointments: [],
    customers_repair_appointments_total: 0,
    customers_repair_appointments_loading: true,
    customers_repair_appointments_params_page: 1,
    customers_repair_appointments_params_limit: 10,

    customers_update_history: [],
    customers_update_history_total: 0,
    customers_update_history_loading: true,
    customers_update_history_params_page: 1,
    customers_update_history_params_limit: 10,

    customers_complaints: [],
    customers_complaints_total: 0,
    customers_complaints_loading: true,
    customers_complaints_params_page: 1,
    customers_complaints_params_limit: 10,

    customers_surveys: [],
    customers_surveys_total: 0,
    customers_surveys_loading: true,
    customers_surveys_params_page: 1,
    customers_surveys_params_limit: 10,

    sourceColumnWarehouse: sourceColumnWarehouseRaw

  } as any);
  const [loadding, setLoadding] = useState(true);
  const isFetchingDetail = useRef(false);
  const { id } = useParams();
  const searchParams = new URLSearchParams(window.location.search);
  const idSync = searchParams.get('id_sync') || '';

  // /customer/merge/preview
  const getDetail = useCallback(async () => {
    if (isFetchingDetail.current) return;
    isFetchingDetail.current = true;
    try {
      const params = sessionStorage.getItem('merge_review_data');
      const res = await mixPostV3('/customer/merge/preview', { ...JSON.parse(params || '{}') });

      res.customers_owner_vehicle.map((val: any, index: any) => {
        if (res.customers_owner_vehicle[index].vehicle_type_category === null || res.customers_owner_vehicle[index].vehicle_type_category === '') {
          res.customers_owner_vehicle[index].vehicle_type_category = 'Khác'
        }
        if (res.customers_owner_vehicle[index].vehicle_type_category === 'TB') {
          res.customers_owner_vehicle[index].vehicle_type_category = 'Tải Bus'
        }
        if (res.customers_owner_vehicle[index].vehicle_type_category === 'DL') {
          res.customers_owner_vehicle[index].vehicle_type_category = 'Du lịch'
        }

        res.customers_owner_vehicle[index].dongxe = res.customers_owner_vehicle[index].vehicle_type_category
      })
      res.customers_owner_vehicle.map((val: any, index: any) => {
        const item = val as any
        Object.keys(item).map((key) => {
          if (!item[key]) {
            item[key] = 'Không xác định'
          }
        })
        res.customers_owner_vehicle[index] = item
      })

      res.customers_used_vehicle.map((val: any, index: any) => {
        if (res.customers_used_vehicle[index].vehicle_type_category === null || res.customers_used_vehicle[index].vehicle_type_category === '') {
          res.customers_used_vehicle[index].vehicle_type_category = 'Khác'
        }
        if (res.customers_used_vehicle[index].vehicle_type_category === 'TB') {
          res.customers_used_vehicle[index].vehicle_type_category = 'Tải Bus'
        }
        if (res.customers_used_vehicle[index].vehicle_type_category === 'DL') {
          res.customers_used_vehicle[index].vehicle_type_category = 'Du lịch'
        }

        res.customers_used_vehicle[index].dongxe = res.customers_used_vehicle[index].vehicle_type_category
      })
      res.customers_used_vehicle.map((val: any, index: any) => {
        const item = val as any
        Object.keys(item).map((key) => {
          if (!item[key]) {
            item[key] = 'Không xác định'
          }
        })
        res.customers_used_vehicle[index] = item
      })

      const xequantam = [] as any
      const xequantam0 = [] as any

      res.customers_interest_vehicle.map((val: any, index: any) => {
        const item = val as any
        Object.keys(item).map((key) => {
          if (!item[key] && key !== 'brand_name' && key !== 'vehicle_name') {
            item[key] = 'Không xác định'
          }
        })
        res.customers_interest_vehicle[index] = item
      })

      res.customers_interest_vehicle.map((val: any) => {
        if (!xequantam0.some((item: any) => item.vehicle_name === (val.vehicle_name || 'Chưa biết'))) {
          xequantam0.push({
            ...val,
            brand: val.vehicle_brand || 'Khác',
            vehicle_name: val.vehicle_name || 'Chưa biết',
            box_code: val.box_code || 'Không xác định',
            latest_date: val.latest_date || 'Không xác định',
            latest_count: val.latest_count || 'Không xác định',
            vehicle_type_category: val.vehicle_type_category ? val.vehicle_type_category === 'TB' ? 'Tải Bus' : 'Du lịch' : 'Khác',
          });
        }
        xequantam.push(
          {
            ...val,
            brand: val.vehicle_brand || 'Khác',
            vehicle_name: val.vehicle_name || 'Chưa biết',
            box_code: val.box_code || 'Không xác định',
            latest_date: val.latest_date || 'Không xác định',
            latest_count: val.latest_count || 'Không xác định',
            vehicle_type_category: val.vehicle_type_category ? val.vehicle_type_category === 'TB' ? 'Tải Bus' : 'Du lịch' : 'Khác',
          }
        )
      })

      setStData((prev: any) => ({
        ...prev,
        ...res.customers_overall,

        contact_person_loading: false,
        contact_person: res.customers_list_contacts || [],
        contact_person_total: res.customers_list_contacts?.length || 0,
        xesohuu: res.customers_owner_vehicle || [],
        xesudung: res.customers_used_vehicle || [],
        xequantam: xequantam || [],
        xequantam0: xequantam0 || [],

        total_service_amount: res.customers_service_invoice_summary.service_invoice_summary.total_service_amount,
        total_service_invoices: res.customers_service_invoice_summary.service_invoice_summary.total_service_invoices,
        service_invoice_dates: res.customers_service_invoice_summary.service_invoice_dates || [],
        service_invoice_service: res.customers_service_invoice_summary.service_invoice_service_list || [],
        service_invoice_service_total: res.customers_service_invoice_summary.service_invoice_summary.total_service_invoices || 0,
        service_invoice_service_loading: false,

        total_vehicle_amount: res.customers_invoice_summary.invoice_summary.total_vehicle_amount,
        total_vehicle_invoices: res.customers_invoice_summary.invoice_summary.total_vehicle_invoices,
        vehicle_invoice_dates: res.customers_invoice_summary.vehicle_invoice_dates || [],
        vehicle_invoice_sale: res.customers_invoice_summary.vehicle_invoice_sale_list || [],
        vehicle_invoice_sale_total: res.customers_invoice_summary.invoice_summary.total_vehicle_invoices || 0,
        vehicle_invoice_sale_loading: false,

        customers_repair_appointments: res.customers_repair_appointments || [],
        customers_repair_appointments_total: res.customers_repair_appointments.length || 0,
        customers_repair_appointments_loading: false,

        customers_complaints: res.customers_complaints || [],
        customers_complaints_total: res.customers_complaints.length || 0,
        customers_complaints_loading: false,

        customers_surveys: res.customers_surveys || [],
        customers_surveys_total: res.customers_surveys.length || 0,
        customers_surveys_loading: false,
      }));
      console.log('res', res);
      setLoadding(false);
    } finally {
      isFetchingDetail.current = false;
    }
  }, []);

  const getDetail0_2 = async () => {
    const res = await mixGetV2(`/api/v1/be/customer/list_contact?id_sync=${idSync}&page=${stData.contact_person_params_page}&limit=${stData.contact_person_params_limit}`);
    setStData((prev: any) => ({
      ...prev,
      contact_person_loading: false,
    }));
    if (res.data) {
      setStData((prev: any) => ({
        ...prev,
        contact_person: res.data.contact_person || [],
        contact_person_total: res.data.total || 0,
      }));
    }
  }
  useEffect(() => {
    if (stData.contact_person_loading === true) {
      getDetail0_2();
    }
  }, [stData.contact_person_loading]);

  const getDetail2_1 = async () => {
    const params = {
      id_sync: idSync,
      page: stData.vehicle_invoice_sale_params_page,
      limit: stData.vehicle_invoice_sale_params_limit,
    } as any;
    if (stData.vehicle_invoice_sale_params_branch_name) {
      params.branch_code = stData.vehicle_invoice_sale_params_branch_name
    }
    if (stData.vehicle_invoice_sale_params_chassis_no) {
      params.chassis_no = stData.vehicle_invoice_sale_params_chassis_no
    }
    const res = await mixGetV2('/api/v1/be/customer/customers_invoice_summary', params);
    setStData((prev: any) => ({
      ...prev,
      vehicle_invoice_sale_loading: false,
    }));
    if (res.data) {
      setStData((prev: any) => ({
        ...prev,
        total_vehicle_amount: res.data.invoice_summary.total_vehicle_amount,
        total_vehicle_invoices: res.data.invoice_summary.total_vehicle_invoices,
        vehicle_invoice_dates: res.data.vehicle_invoice_dates || [],
        vehicle_invoice_sale: res.data.vehicle_invoice_sale_list || [],
        vehicle_invoice_sale_total: res.data.total || 0,
      }));
    }
  }
  useEffect(() => {
    if (stData.vehicle_invoice_sale_loading === true) {
      getDetail2_1();
    }
  }, [stData.vehicle_invoice_sale_loading]);

  const getDetail2_2 = async () => {
    const params = {
      id_sync: idSync,
      page: stData.service_invoice_service_params_page,
      limit: stData.service_invoice_service_params_limit,
    } as any
    if (stData.service_invoice_service_params_branch_name) {
      params.branch_code = stData.service_invoice_service_params_branch_name
    }
    if (stData.service_invoice_service_params_chassis_no) {
      params.chassis_no = stData.service_invoice_service_params_chassis_no
    }
    const res = await mixGetV2('/api/v1/be/customer/customers_service_invoice_summary', params);
    setStData((prev: any) => ({
      ...prev,
      service_invoice_service_loading: false,
    }));
    if (res.data) {
      setStData((prev: any) => ({
        ...prev,
        total_service_amount: res.data.service_invoice_summary.total_service_amount,
        total_service_invoices: res.data.service_invoice_summary.total_service_invoices,
        service_invoice_dates: res.data.service_invoice_dates || [],
        service_invoice_service: res.data.service_invoice_service_list || [],
        service_invoice_service_total: res.data.total || 0,
      }));
    }
  }
  useEffect(() => {
    if (stData.service_invoice_service_loading === true) {
      getDetail2_2();
    }
  }, [stData.service_invoice_service_loading]);

  const getDetail3_1 = async () => {
    const res = await mixGetV2(`/api/v1/be/customer/customers_repair_appointments?id_sync=${idSync}&page=${stData.customers_repair_appointments_params_page}&limit=${stData.customers_repair_appointments_params_limit}`);
    setStData((prev: any) => ({
      ...prev,
      customers_repair_appointments_loading: false,
    }));
    if (res.data) {
      setStData((prev: any) => ({
        ...prev,
        customers_repair_appointments: res.data.appointments || [],
        customers_repair_appointments_total: res.data.total || 0,
      }));
    }
  }
  useEffect(() => {
    if (stData.customers_repair_appointments_loading === true) {
      getDetail3_1();
    }
  }, [stData.customers_repair_appointments_loading]);

  const getUpdateHistory = async () => {
    const res = await mixGetV2(`/api/v1/be/customer/customers_logs?id_sync=${idSync}&page=${stData.customers_update_history_params_page}&limit=${stData.customers_update_history_params_limit}`);
    setStData((prev: any) => ({
      ...prev,
      customers_update_history_loading: false,
    }));
    if (res.data) {
      const temp = [] as any
      res.data.logs.map((val: any) => {
        const arrTime = val.created_at.split(' ')
        let user = 'Hệ thống'
        if (val.user_id === 1) {
          user = 'Admin'
        }
        temp.push({
          id: val.id,
          date: arrTime[0],
          time: arrTime[1],
          user: val.account?.fullname || user,
          department: "",
          email: val.account?.email || "",
          actions: [
            { text: val.detail },
            { text: val.from_source },
          ],
        })
      })
      setStData((prev: any) => ({
        ...prev,
        customers_update_history: temp,
        customers_update_history_total: res.data.total || 0,
      }));
    }
  }
  useEffect(() => {
    if (stData.customers_update_history_loading === true) {
      getUpdateHistory();
    }
  }, [stData.customers_update_history_loading]);

  const getCustomersComplaints = async () => {
    const res = await mixGetV2(`/api/v1/be/customer/customers_complaints?id_sync=${idSync}&page=${stData.customers_complaints_params_page}&limit=${stData.customers_complaints_params_limit}`);
    setStData((prev: any) => ({
      ...prev,
      customers_complaints_loading: false,
    }));
    if (res.data) {
      setStData((prev: any) => ({
        ...prev,
        customers_complaints: res.data.complaints || [],
        customers_complaints_total: res.data.total || 0,
      }));
    }
  }
  useEffect(() => {
    if (stData.customers_complaints_loading === true) {
      getCustomersComplaints();
    }
  }, [stData.customers_complaints_loading]);

  const getCustomersSurveys = async () => {
    const res = await mixGetV2(`/api/v1/be/customer/customers_surveys?id_sync=${idSync}&page=${stData.customers_surveys_params_page}&limit=${stData.customers_surveys_params_limit}`);
    setStData((prev: any) => ({
      ...prev,
      customers_surveys_loading: false,
    }));
    if (res.data) {
      setStData((prev: any) => ({
        ...prev,
        customers_surveys: res.data.surveys || [],
        customers_surveys_total: res.data.total || 0,
      }));
    }
  }
  useEffect(() => {
    if (stData.customers_surveys_loading === true) {
      getCustomersSurveys();
    }
  }, [stData.customers_surveys_loading]);

  useEffect(() => {
    getDetail();
  }, []);

  const [isTab, setIsTab] = useState<number>(1)

  const [openExportModal, setOpenExportModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportUrl, setExportUrl] = useState<string | null>(null);
  const [exportError, setExportError] = useState<string | null>(null);

  const fetchUserExportConfigs = async (): Promise<Record<string, Record<string, { width?: number; hide?: boolean; order?: number }>>> => {
    try {
      const res: any = await mixPostV2('/api/v1/be/user_thaco_json_more', {
        user_id_thaco: user.id,
        name: JSON.stringify(EXPORT_JSON_CACHE_NAMES),
      });
      const byName: Record<string, Record<string, { width?: number; hide?: boolean; order?: number }>> = {};
      if (res?.status && Array.isArray(res?.data?.items)) {
        res.data.items.forEach((item: any) => {
          try {
            byName[item.name] = item.data_json ? JSON.parse(item.data_json) : {};
          } catch (parseErr) {
            console.warn(`[Export] Failed to parse data_json for cache "${item.name}":`, parseErr);
            byName[item.name] = {};
          }
        });
      }
      return byName;
    } catch (_) {
      // ignore, fallback will be used
    }
    return {};
  };

  const buildExportJsonFromUserConfig = (
    dataJson: Record<string, { width?: number; hide?: boolean; order?: number }>
  ): Array<{ label: string; key: string; pos: number }> => {
    const entries = Object.entries(dataJson)
      .filter(([key, cfg]) => key !== 'action' && cfg.hide !== true)
      .sort(([, a], [, b]) => (a.order ?? 0) - (b.order ?? 0));

    return entries.map(([key, cfg], index) => {
      const label = getLabelFromSourceColumnWarehouse(key);
      return { label, key, pos: index };
    });
  };

  const defaultExportJson = [
    {
      type_api: 1,
      data: [
        { label: 'Email', key: 'cus_email', pos: 1 },
        { label: 'Điện thoại', key: 'cus_tel', pos: 2 },
        { label: 'Họ tên', key: 'cus_name', pos: 3 },
      ],
    },
    {
      type_api: 2,
      data: [
        { label: 'Email', key: 'cus_email', pos: 0 },
        { label: 'Mã CRM', key: 'cus_crm', pos: 1 },
      ],
    },
    {
      type_api: 4,
      data: [
        { label: 'Loại xe', key: 'vehicle_type', pos: 0 },
        { label: 'Thương hiệu xe', key: 'vehicle_brand', pos: 1 },
      ],
    },
  ];

  const handleExportCustomer = async () => {
    setOpenExportModal(true);
    setExportLoading(true);
    setExportUrl(null);
    setExportError(null);
    try {
      const configsByName = await fetchUserExportConfigs();

      const jsonToSend: Array<{ type_api: number; data: Array<{ label: string; key: string; pos: number }> }> = [];

      for (const cacheConfig of EXPORT_JSON_CACHE_CONFIG) {
        const { name: cacheName, type_api: typeApi } = cacheConfig;
        if (!typeApi || typeApi === 66 || typeApi === 77) continue;

        const cfg = configsByName[cacheName];
        if (cfg && Object.keys(cfg).length > 0) {
          let fields = buildExportJsonFromUserConfig(cfg);
          if (fields.length > 0) {
            if(typeApi === 1) {
              fields = [
                { label: 'Họ tên', key: 'cus_name', pos: -4 },
                { label: 'Điện thoại', key: 'cus_tel', pos: -3 },
                { label: 'Email', key: 'cus_email', pos: -2 },
                { label: 'Mã CID', key: 'cus_crm', pos: -1 },
                ...fields,
              ]
              const temp = [] as any
              fields.map((val, index) => {
                temp.push({
                  ...val,
                  pos: index
                })
              })
              fields = temp
            }
            if(typeApi === 3) {
              fields = [
                { label: 'Thương hiệu xe', key: 'vehicle_brand', pos: -1 },
                ...fields,
              ]
              const temp = [] as any
              fields.map((val, index) => {
                temp.push({
                  ...val,
                  pos: index
                })
              })
              fields = temp
            }
            if(typeApi === 4) {
              fields = [
                { label: 'Thương hiệu xe', key: 'vehicle_brand', pos: -1 },
                ...fields,
              ]
              const temp = [] as any
              fields.map((val, index) => {
                temp.push({
                  ...val,
                  pos: index
                })
              })
              fields = temp
            }
            if(typeApi === 6) {
              const fieldDetails = buildExportJsonFromUserConfig(configsByName['TbCacheVehicleInvoiceDetail'] || {});
              fields = [
                ...fields,
                ...fieldDetails.map(f => ({ ...f, pos: (f.pos || 0) + fields.length })),
              ]
            }
            if(typeApi === 7) {
              const fieldDetails = buildExportJsonFromUserConfig(configsByName['TbCacheServiceMaintenanceInvoiceDetail'] || {});
              fields = [
                ...fields,
                ...fieldDetails.map(f => ({ ...f, pos: (f.pos || 0) + fields.length })),
              ]
            }
            jsonToSend.push({ type_api: typeApi, data: fields });
            continue;
          }
        }

        // Fallback: use the corresponding default block for this type_api
        const fallbackBlock = defaultExportJson.find((b) => b.type_api === typeApi);
        if (fallbackBlock) {
          jsonToSend.push(fallbackBlock);
        }
      }

      if (jsonToSend.length === 0) {
        console.warn('[Export] No dynamic blocks built from cache configs; falling back to defaultExportJson.');
      }

      console.log(jsonToSend, 'jsonToSend');

      const payload = {
        id_sync: idSync,
        json: JSON.stringify(jsonToSend.length > 0 ? jsonToSend : defaultExportJson),
      };
      const res: any = await mixPostV2('/api/v1/be/file_customer/import', payload);
      if (res?.status) {
        const url = res?.data?.file_url;
        if (!url) {
          setExportError('Không nhận được URL tải về từ hệ thống.');
        } else {
          setExportUrl(url);
        }
      } else {
        setExportError(res?.message || 'Xuất dữ liệu thất bại.');
      }
    } catch (e: any) {
      setExportError(e?.message || 'Có lỗi xảy ra khi xuất dữ liệu.');
    } finally {
      setExportLoading(false);
    }
  };

  const closeExportModal = () => {
    if (exportLoading) return;
    setOpenExportModal(false);
  };

  // tab
  const onChange = (key: string) => {
    setIsTab(Number(key));
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Tổng quan</span>,
      children: <Overview stData={stData} stChange={(data) => {
        setStData((prev: any) => ({
          ...prev,
          ...data
        }))
      }} />,
    },
    {
      key: '2',
      label: <span className='custom-page-css font-light text-lg'>Thông tin xe</span>,
      children: <VehicleInformation stData={stData} stChange={(data) => {
        setStData((prev: any) => ({
          ...prev,
          ...data
        }))
      }} />,
    },
    {
      key: '3',
      label: <span className='custom-page-css font-light text-lg'>Lịch sử hóa đơn</span>,
      children: <InvoiceHistory stData={stData} stChange={(data) => {
        setStData((prev: any) => ({
          ...prev,
          ...data
        }))
      }} />,
    },
    {
      key: '4',
      label: <span className='custom-page-css font-light text-lg'>Lịch sử tương tác</span>,
      children: <InteractionHistory stData={stData} stChange={(data) => {
        console.log('data', data);
        setStData((prev: any) => ({
          ...prev,
          ...data
        }))
      }} />,
    },
  ];

  return (
    <Layout>
      <div className="custom-page-css flex items-center justify-between">
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/customer/pooling-data">Khách hàng</Link>, },
            { title: <Link to="/customer/pooling-data/customer-list">Danh sách khách hàng đã được làm sạch</Link>, },
            { title: 'Thông tin khách hàng', },
          ]}
          title='Thông tin khách hàng'
          historyBack='/customer/pooling-data/customer-list'
          className="gutter-block-end"
        />

      </div>
      <Modal
        open={openExportModal}
        onCancel={closeExportModal}
        footer={null}
        title="Xuất dữ liệu khách hàng"
        maskClosable={!exportLoading}
        closable={!exportLoading}
        destroyOnClose
      >
        {exportLoading && (
          <div className="custom-page-css flex items-center gap-2">
            <Spin />
            <span>Dữ liệu đang được chuẩn bị, vui lòng chờ...</span>
          </div>
        )}
        {!exportLoading && exportError && (
          <Typography.Text type="danger">{exportError}</Typography.Text>
        )}
        {!exportLoading && exportUrl && (
          <div className="custom-page-css flex flex-col gap-2">
            <Typography.Text>Dữ liệu đã sẵn sàng. Nhấn để tải về:</Typography.Text>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => window.open(exportUrl, '_blank')}
            >
              Tải về
            </Button>
            {/* <Typography.Text type="secondary" style={{ wordBreak: 'break-all' }}>
              {exportUrl}
            </Typography.Text> */}
          </div>
        )}
      </Modal>
      {loadding ?
        <Skeleton active avatar paragraph={{ rows: 4 }} />
        :
        <div className="custom-page-css w-full flex flex-column gap-2">
          <div className={isTab !== 1 ? '' : 'hidden '} >
            <Infomation stData={stData} />
          </div>
          <div className="custom-page-css w-full h-full flex gap-2">
            <div className={isTab == 1 ? 'custom-page-css h-full w-1-4 shrink-0 transition overflow-y-scroll' : 'hidden '} >
              <InfomationLeft stData={stData} />
            </div>
            <div className="custom-page-css w-full h-full">
              <Tabs
                defaultActiveKey="1"
                items={items}
                onChange={onChange}
              />
            </div>
          </div>

        </div>
      }
    </Layout>

  );
};
export default CustomerInforNew
